import { responseCodes } from './enums/response-codes';

const getPrintStatusRequest = () => {
  const payload = `${responseCodes.RECEIPT_INFORMATION}0`; // 0 means print OK

  return Buffer.from(payload, 'utf-8').toString('hex');
};

export { getPrintStatusRequest };
